module.exports = __webpack_public_path__ + "img/images.9604f4d6.svg";